import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-plus" }, null, -1)
const _hoisted_2 = ["onClick"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-edit" }, null, -1)

import {onMounted, ref} from 'vue';
import {
  CompositeFilterDescriptor,
  toDataSourceRequestString
} from '@progress/kendo-data-query';

import {getPropertyName, getDeepPropertyName} from '@fluffy-spoon/name-of';
import {Grid, GridColumnProps} from '@progress/kendo-vue-grid';
import {useI18n} from 'vue-i18n';
import router from '@/router';
import Card from '@/components/card/card.vue';
import AppButton from '@/components/button/button.vue';

import CustomersDevicesService from '@/services/customersDevicesClient';
import {CustomersDevice} from '@/interfaces/customersDevice';


const __default__ = {name: 'customers-devices-list'};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const {t} = useI18n();
const gridDiv = ref(null);
const gridWidth = ref(0);
const skip = ref(0);
const take = ref(10);
const total = ref(100);
const sort = ref([]);
const filter = ref<CompositeFilterDescriptor>(null);

const gridData = ref([]);

function onDetailButtonClick(id?: string) {
  router.push({name: 'customers-device-detail', params: {id: id}});
}

onMounted(async () => {
  await getGridData();
});
const columns: GridColumnProps[] = [
  // {
  //   field: getPropertyName<Customer>((p) => p.id),
  //   title: t('areas.customers.columns.' + getPropertyName<Customer>((p) => p.id)),
  //   filterable: false,
  //   width: 100 //setPercentage(10)
  // },
  {
    field: getPropertyName<CustomersDevice>((p) => p.description),
    title: t(
      'areas.customersDevices.columns.' +
        getPropertyName<CustomersDevice>((p) => p.description)
    ),
    filterable: true,
    filter: 'text'
    //width: setPercentage(40)
  },
  {
    field: getDeepPropertyName<CustomersDevice>((p) => p.customer.businessName),
    title: t(
      'areas.customersDevices.columns.' + getPropertyName<CustomersDevice>((p) => p.customer.businessName)
    ),
    filter: 'text'
    //width: setPercentage(40)
  },
  {
    field: getPropertyName<CustomersDevice>((p) => p.serial),
    title: t(
      'areas.customersDevices.columns.' + getPropertyName<CustomersDevice>((p) => p.serial)
    ),
    filter: 'text'
    //width: setPercentage(40)
  },
  {
    title: '',
    cell: 'goToDetailButton',
    filterable: false,
    width: 100
  }
];

async function dataStateChange(event: any) {
  sort.value = event.data.sort;
  skip.value = event.data.skip;
  take.value = event.data.take;
  filter.value = event.data.filter;

  await getGridData();
}

async function getGridData() {
  const dataSourceRequestString = toDataSourceRequestString({
    skip: skip.value,
    take: take.value,
    sort: sort.value,
    filter: filter.value
  });

  const response = await CustomersDevicesService.customersDevicesGET(
    dataSourceRequestString
  );
  gridData.value = response.data;
  total.value = response.total;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Card, {
    title: _ctx.$t('areas.customersDevices.title')
  }, {
    tools: _withCtx(() => [
      _createVNode(AppButton, {
        class: "btn btn-outline-primary",
        type: "button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (onDetailButtonClick()))
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createTextVNode(" " + _toDisplayString(_ctx.$t('areas.customersDevices.labels.new')), 1)
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(Grid), {
        columns: columns,
        "data-items": gridData.value,
        filter: filter.value,
        filterable: true,
        skip: skip.value,
        sort: sort.value,
        sortable: true,
        take: take.value,
        total: total.value,
        onDatastatechange: dataStateChange
      }, {
        goToDetailButton: _withCtx(({props}) => [
          _createElementVNode("button", {
            class: "btn btn-primary btn-sm text-center m-1",
            onClick: ($event: any) => (onDetailButtonClick(props.dataItem.id))
          }, [
            _hoisted_3,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('areas.customersDevices.labels.edit')), 1)
          ], 8, _hoisted_2)
        ]),
        _: 1
      }, 8, ["data-items", "filter", "skip", "sort", "take", "total"])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})